import {apiV1} from "../../../services/api";
import {IInvalidateCacheFormState} from "../Translations/InvalidateCacheAction";

export const invalidateCache = (data: IInvalidateCacheFormState): Promise<boolean> => {
    return apiV1.POST( `/translations/${data.language}/invalidate_cache`);
};
